import { render, staticRenderFns } from "./OppoList.vue?vue&type=template&id=5bff88b6&"
import script from "./OppoList.vue?vue&type=script&lang=js&"
export * from "./OppoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports